'use strict';

exports.__esModule = true;
exports['default'] = {
  optional: ' (optional)',
  required: '',
  add: 'Add',
  remove: 'Remove',
  up: 'Up',
  down: 'Down'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/lib/i18n/en.js
 ** module id = 1024
 ** module chunks = 0
 **/